import axios from "axios";
import config from "@config";

const API = `${config.api}/admin/artists`;

// Возвращает всех артистов
export const getArtists = (params) =>
  axios
    .get(`${API}`, { params, withCredentials: true })
    .then((res) => res.data)
    .catch((err) => err.response.data || { error: true, message: err.message });

// Возвращает артиста по ID
export const getArtist = (params) =>
  axios
    .get(`${API}/id/${params.id}`, { params, withCredentials: true })
    .then((res) => res.data)
    .catch((err) => err.response.data || { error: true, message: err.message });

// Обновляет трек
export const updateArtist = (data) =>
  axios
    .post(`${API}/update/id/${data.id}`, data.data, { withCredentials: true })
    .then((res) => res.data)
    .catch((err) => err.response.data || { error: true, message: err.message });
